var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"elevation":"0","id":"app-bar","app":"","height":"56px"}},[_vm._t("start"),_c('v-spacer'),_vm._t("center"),_c('v-spacer'),_vm._t("end")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }